/**
 * Ant Design 主题配置
 * 完全自定义的主题系统，基于Design Tokens
 * 限制: <100行
 */

import type { ThemeConfig } from 'antd';
import { brandColors, functionalColors, neutralColors } from './tokens/colors';
import { fontFamily, fontSize } from './tokens/typography';
import { boxShadow } from './tokens/effects';
import { componentThemes } from './theme/components';

// ============ 主题配置 ============
export const customTheme: ThemeConfig = {
  // 全局Token配置
  token: {
    // ======== 颜色 ========
    colorPrimary: brandColors.primary.main,
    colorSuccess: functionalColors.success.main,
    colorWarning: functionalColors.warning.main,
    colorError: functionalColors.error.main,
    colorInfo: functionalColors.info.main,

    // 文本颜色
    colorText: neutralColors.gray[900],
    colorTextSecondary: neutralColors.gray[600],
    colorTextTertiary: neutralColors.gray[500],
    colorTextQuaternary: neutralColors.gray[400],

    // 背景颜色
    colorBgContainer: neutralColors.white,
    colorBgElevated: neutralColors.white,
    colorBgLayout: neutralColors.gray[50],

    // 边框颜色
    colorBorder: neutralColors.gray[200], // Softer border
    colorBorderSecondary: neutralColors.gray[100],

    // ======== 字体 ========
    fontFamily: fontFamily.base,
    fontSize: 14,
    fontSizeHeading1: parseInt(fontSize['5xl']),
    fontSizeHeading2: parseInt(fontSize['4xl']),
    fontSizeHeading3: parseInt(fontSize['3xl']),
    fontSizeHeading4: parseInt(fontSize['2xl']),
    fontSizeHeading5: parseInt(fontSize.xl),

    // ======== 圆角 (More rounded for modern feel) ========
    borderRadius: 8,
    borderRadiusLG: 12,
    borderRadiusSM: 6,
    borderRadiusXS: 4,

    // ======== 阴影 ========
    boxShadow: boxShadow.base,
    boxShadowSecondary: boxShadow.sm,

    // ======== 动画 ========
    motionDurationFast: '0.15s',
    motionDurationMid: '0.2s',
    motionDurationSlow: '0.3s',
    motionEaseInOut: 'cubic-bezier(0.4, 0, 0.2, 1)',
    motionEaseOut: 'cubic-bezier(0, 0, 0.2, 1)',

    // ======== 行高 ========
    lineHeight: 1.5,
    lineHeightHeading1: 1.2,
    lineHeightHeading2: 1.25,
    lineHeightHeading3: 1.3,
    lineHeightHeading4: 1.4,
    lineHeightHeading5: 1.5,
  },

  // ============ 组件级配置 ============
  components: componentThemes,

  // ============ 算法配置 ============
  algorithm: undefined,
};

// ============ 暗色主题配置 ============
export const darkTheme: ThemeConfig = {
  ...customTheme,
  token: {
    ...customTheme.token,
    colorText: neutralColors.white,
    colorTextSecondary: neutralColors.gray[400],
    colorTextTertiary: neutralColors.gray[500],
    colorBgContainer: neutralColors.gray[800],
    colorBgElevated: neutralColors.gray[900],
    colorBgLayout: neutralColors.black,
    colorBorder: neutralColors.gray[700],
    colorBorderSecondary: neutralColors.gray[800],
  },
};

export default customTheme;
